// extracted by mini-css-extract-plugin
export default {"calendar":"Calendar__calendar___CuXUb"};